export default {
  'addContact.noSpecialCharacters': 'No Special Characters Permitted',
  'addContact.abaSwiftCode': 'Bank Code',
  'addContact.accountNumber': 'Account Number',
  'addContact.accountType': 'Account Type',
  'addContact.addEmail': 'Add Email',
  'addContact.addPaymentInformation': 'Add Payment Details',
  'addContact.address1': 'Line 1',
  'addContact.address2': 'Line 2',
  'addContact.address3': 'Line 3',
  'addContact.addressRequiredWirePayments': 'A Physical Address is required for Wire Payments.',
  'addContact.allNames': '(BUSINESS, INDIVIDUAL, OR EMPLOYEE)',
  'addContact.businessName': 'Business Name',
  'addContact.bankCode': 'Bank Code',
  'addContact.bankCodeInvalid': 'Bank Code Invalid',
  'addContact.contactAddress': 'Contact Address',
  'addContact.contactDetails': 'Contact Details',
  'addContact.contactInformation': 'Contact Information',
  'addContact.contactName': 'Contact Person',
  'addContact.contactTypes': 'Contact Types',
  'addContact.email1': 'Email 1',
  'addContact.email2': 'Email 2',
  'addContact.extension': 'Ext',
  'addContact.invalidPhone': 'Phone number should be 10 digits',
  'addContact.payeeAddress': 'Payee Address',
  'addContact.payeeDetails': 'Payee Details',
  'addContact.payeeInformation': 'Payee Information',
  'addContact.payeeTypes': 'Payee Types',
  'addContact.paymentType': 'Payment Type',
  'addContact.plural': 'Payment Type(s)',
  'addContact.addPaymentType': 'Add Payment Type(s)',
  'addContact.noPoBox': 'No P.O. Box Address',
  'addContact.intermediaryBankLabel': 'Intermediary Bank',
  'addContact.intermediaryBank': 'Intermediary Bank <%= num %>',
  'addContact.selectBankCodeType': 'Select Bank Code Type',
  'addContact.idExtra': 'ID # can be used to identify a payee when duplicate name exists',
  'addContact.physicalAddressRequiredNoPoBox': 'Physical Address Required. No P.O. Box Address',
  'addContact.addressRequired': 'Address required',
  'addContact.payeeWasNotModified': 'Payee was not modified',
  'addContact.selectPayeeType': 'Please select Payee Type',
  'addContact.addressUpdateRequired':
    'Payee address fields have been updated. Please re-enter the payee address for expedited or international payments.',
  'addContact.oldAddress':
    'System requires the payee address to be re-entered. The payee address information is as follows.'
};
